// extracted by mini-css-extract-plugin
export default {"suggestions":"fDnuE6","suggestions__title":"dxckfF"};